// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1079":"3528e056","4785":"03413ace","5886":"5f838362"}[chunkId] + ".chunk.css";
};